module.exports = __webpack_public_path__ + "img/7asanat-logo.0b1534d3.png";